import { categories, getCategoryIcon } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-2">
            All Product Categories
          </h2>
          <p className="text-sm text-foreground-600 max-w-[600px] mx-auto">
            Explore our complete collection of shopping categories with carefully curated product spreadsheets
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center justify-center p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-2.5 group-hover:bg-accent-200 transition-colors">
                <i className={`ri-${getCategoryIcon(cat.slug)} text-lg md:text-xl`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-800 text-center leading-tight whitespace-nowrap">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}